import { Component, defineComponent } from 'vue';

import {
	SelectedFilters,
	SearchFilterContainer,
	AttendanceFilter,
	DegreeTypeFilter,
	DisciplineFilter,
	DurationFilter,
	FormatFilter,
	LocationFilter,
	LocationV2Filter,
	SpecialProgrammesFilter,
	TuitionFeeFilter,
} from '@studyportals/search-filters';
import { Experiment } from '@/study-search/platform/Experiment';
import { PortalType } from '@studyportals/domain-client';

export default defineComponent({
	components: {
		SelectedFilters: SelectedFilters as Component,
		SearchFilterContainer: SearchFilterContainer as Component,
		DisciplineFilter: DisciplineFilter as Component,
		AttendanceFilter: AttendanceFilter as Component,
		DegreeTypeFilter: DegreeTypeFilter as Component,
		DurationFilter: DurationFilter as Component,
		FormatFilter: FormatFilter as Component,
		LocationFilter: LocationFilter as Component,
		LocationV2Filter: LocationV2Filter as Component,
		SpecialProgrammesFilter: SpecialProgrammesFilter as Component,
		TuitionFeeFilter: TuitionFeeFilter as Component,
	},
	setup: () => {
		return {
			isExperimentVariation1: Experiment.isExperimentVariation(1, 'location_filter_redesign', [PortalType.MASTER]),
		};
	},
});
